import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import { CardHeader } from 'components/ui/card';

interface CardImageSectionProps {
    hasImage: boolean;
    thumbnailImageUrl?: string;
    name: string;
    icon: string;
    iconBgColor: string;
}

export const CardImageSection: React.FC<CardImageSectionProps> = ({
    hasImage,
    thumbnailImageUrl,
    name,
    icon,
    iconBgColor
}) => {
    return (
        <CardHeader className="p-0">
            <div
                className="relative aspect-video flex items-center justify-center overflow-hidden"
                style={{
                    background: 'linear-gradient(180deg, var(--tailwind-colors-neutral-50, rgba(250, 250, 250, 0.20)) 0%, var(--tailwind-colors-neutral-400, rgba(163, 163, 163, 0.20)) 100%)'
                }}
            >
                {hasImage ? (
                    <img
                        src={thumbnailImageUrl}
                        alt={name}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="project-icon flex items-center justify-center w-full h-full">
                        <span
                            style={{
                                boxShadow:
                                    'inset 0 0 4px 0 rgba(0, 0, 0, 0.10)'
                            }}
                            className={cn("p-5 rounded-full inline-flex", iconBgColor)}
                        >
                            <FontAwesomeIcon
                                icon={icon}
                                style={{ fontSize: '18px' }}
                            />
                        </span>
                    </div>
                )}
            </div>
        </CardHeader>
    );
};

